import { useFeatureFlag } from '@moda/portal-stanchions';

export const useEnableClubModa = () =>
  useFeatureFlag('enable-club-moda-treatment', [{ default: false }, { if: true, then: true }]);
